<script setup lang="ts">
const { assistantSettings } = useAssistantSettingsStore();
</script>

<template>
  <div class="chat-intro">
    <AssistantAvatar class="avatar"></AssistantAvatar>
    <div>
      <BaseHeading class="heading">
        {{ assistantSettings.text.intro_title }}
      </BaseHeading>
      <p class="paragraph">
        {{ assistantSettings.text.intro_text }}
      </p>
    </div>
    <ChatDisclaimer class="disclaimer" :line-clamp="3" />
  </div>
</template>

<style lang="scss" scoped>
.chat-intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  font-size: 0.9rem;
  text-align: center;
  padding: 20px;
}

.avatar {
  width: 100px;
}
</style>
